module.exports = __webpack_public_path__ + "static/pattern-multi-dimension-analytics-b4129227c1206a2e4936d780ec0fc107.png";